let api_initialized = false;

export default (key) => {
	// Do nothing if run from server-side
	if (typeof document === 'undefined') return;
	if (!api_initialized) {
	    const url = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places,drawing&callback=googleMapsInit&language=en`;
	    const script = document.createElement('script')
	    script.setAttribute('src', url)
	    script.setAttribute('async', '')
	    script.setAttribute('defer', '')
	    document.head.appendChild(script)
	  	api_initialized = true;
	}
}